var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"glide stepper"},[_c('div',{staticClass:"glide__track",attrs:{"data-glide-el":"track"}},[_c('ul',{staticClass:"glide__slides"},[_vm._t("default",null,{"activeStep":_vm.index})],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }